/**
 * Viewer identity for Gimmonix /orderByID pre-fetch (payment link guard).
 * Uses decrypted getUserInfo — not raw localStorage JSON.parse.
 */

export const CREDIT_CARD_DETAILS_VIEWER_CONTEXT_TRACE =
  "[CREDIT_CARD_DETAILS_VIEWER_CONTEXT_TRACE]";

/** @param {Record<string, unknown> | null | undefined} userInfo */
export function resolvePaymentViewerAgentId(userInfo) {
  if (!userInfo || typeof userInfo !== "object") return null;
  const id = userInfo.id ?? userInfo.agent_id;
  if (id == null || id === "") return null;
  return id;
}

/**
 * Body fields for getDelayedPayOrder / gimmonix orderByID — matches paymentagent.jsx.
 * @param {Record<string, unknown> | null | undefined} userInfo
 * @param {boolean} isAdmin
 */
export function buildGimmonixOrderByIdViewerPayload(userInfo, isAdmin) {
  const agentID = userInfo?.id || userInfo?.agent_id || 0;
  return {
    agentID,
    isAdmin: isAdmin ? 1 : 0,
  };
}

/** @param {unknown} agentID @param {number | boolean} isAdmin */
export function resolveCreditCardDetailsViewerContextStatus(agentID, isAdmin) {
  const hasAgent =
    agentID != null && agentID !== "" && Number(agentID) !== 0;
  const admin = isAdmin === 1 || isAdmin === true;
  return hasAgent || admin ? "PASS" : "FAIL";
}

/**
 * @param {{
 *   orderId?: unknown,
 *   idSource?: unknown,
 *   userInfo?: Record<string, unknown> | null,
 *   isAdmin?: boolean,
 *   sourceResolver?: string,
 * }} opts
 */
export function buildCreditCardDetailsViewerContextTrace({
  orderId,
  idSource,
  userInfo,
  isAdmin = false,
  sourceResolver = "getUserInfo|authService.isAdminUser",
}) {
  const agentID = userInfo?.id || userInfo?.agent_id || null;
  const isAdminFlag = isAdmin ? 1 : 0;
  return {
    orderId: orderId ?? null,
    idSource: idSource ?? null,
    agentID,
    isAdmin: isAdminFlag,
    hasUserInfo: Boolean(userInfo),
    sourceResolver,
    status: resolveCreditCardDetailsViewerContextStatus(agentID, isAdminFlag),
  };
}

/** @param {Record<string, unknown>} payload */
export function logCreditCardDetailsViewerContextTrace(payload) {
  if (typeof import.meta !== "undefined" && !import.meta.env?.DEV) return;
  try {
    // eslint-disable-next-line no-console
    console.info(CREDIT_CARD_DETAILS_VIEWER_CONTEXT_TRACE, payload);
  } catch {
    /* ignore */
  }
}

/**
 * Simulates legacy raw JSON.parse on encrypted UserInfo (always fails).
 * @param {string | null} rawStored
 */
export function legacyRawUserInfoAgentId(rawStored) {
  if (!rawStored) return null;
  try {
    const parsed =
      typeof rawStored === "string" ? JSON.parse(rawStored) : rawStored;
    const id = parsed?.id ?? parsed?.agent_id;
    return id != null ? id : null;
  } catch {
    return null;
  }
}
